import { SEARCH_FILTER_TYPE } from '@/features/shared/constants/global'
import { type SearchParams } from '@/features/shop/services/Search/types'

export const getResetSearchParams = (filterType: string): SearchParams => {
  switch (filterType) {
    case SEARCH_FILTER_TYPE.ACTIVE_DEALS:
      return { active_deals: false }
    case SEARCH_FILTER_TYPE.CATEGORY:
      return { category_id: undefined }
    case SEARCH_FILTER_TYPE.SORT_BY:
      return { sort: undefined }
    case SEARCH_FILTER_TYPE.BRAND:
      return { brands: undefined }
    case SEARCH_FILTER_TYPE.FLAVOR:
      return { flavors: undefined }
    case SEARCH_FILTER_TYPE.STORE:
      return { contexts: undefined }
    default:
      return {}
  }
}
